import React, { useState } from 'react';
import { Car, Search, X } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const BrandFilter = ({ brands, selectedBrands = [], onSelect }) => {
  const { t } = useLanguage();
  const [searchQuery, setSearchQuery] = useState('');

  // Filtrer les marques selon la recherche
  const filteredBrands = brands.filter(brand => 
    brand.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Toggle une marque dans la sélection multiple
  const toggleBrand = (brandId) => {
    if (brandId === 'all') {
      onSelect([]);
      return;
    }

    let newSelection;
    if (selectedBrands.includes(brandId)) {
      newSelection = selectedBrands.filter(id => id !== brandId);
    } else {
      newSelection = [...selectedBrands, brandId];
    }
    
    onSelect(newSelection);
  };

  // Supprimer une marque de la sélection
  const removeBrand = (brandId) => {
    const newSelection = selectedBrands.filter(id => id !== brandId);
    onSelect(newSelection);
  };

  const isSelected = (brandId) => {
    if (brandId === 'all') return selectedBrands.length === 0;
    return selectedBrands.includes(brandId);
  };

  // Obtenir le label d'une marque par son id
  const getBrandLabel = (brandId) => {
    const brand = brands.find(b => b.id === brandId);
    return brand ? brand.label : brandId;
  };

  return (
    <div className="py-6 bg-white border-b border-gray-100">
      <div className="container mx-auto px-4">
        
        {/* Titre */}
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
          <Car className="w-5 h-5 text-[#27489E]" /> {t('brands.title')}
        </h3>

        {/* Barre de recherche avec tags */}
        <div className="relative mb-4">
          <div className="flex items-center flex-wrap gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 focus-within:border-[#27489E] focus-within:bg-white transition">
            <Search className="w-5 h-5 text-gray-400 flex-shrink-0" />
            
            {/* Tags des marques sélectionnées */}
            {selectedBrands.map((brandId) => (
              <span 
                key={brandId}
                className="flex items-center gap-1.5 bg-[#27489E] text-white px-3 py-1 rounded-lg text-sm font-medium"
              >
                <span>{getBrandLabel(brandId)}</span>
                <button 
                  onClick={() => removeBrand(brandId)}
                  className="hover:bg-white/20 rounded-full p-0.5 transition"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              </span>
            ))}
            
            {/* Input de recherche */}
            <input
              type="text"
              placeholder={selectedBrands.length === 0 ? t('brands.searchPlaceholder') : t('brands.addBrand')}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="flex-1 min-w-[150px] bg-transparent outline-none text-gray-800 placeholder-gray-400"
            />
          </div>
        </div>

        {/* Grille des marques */}
        <div className="flex flex-wrap gap-2">
          {filteredBrands.map((brand) => (
            <button
              key={brand.id}
              onClick={() => toggleBrand(brand.id)}
              className={`
                px-4 py-2.5 rounded-xl border text-sm font-medium transition-all
                ${isSelected(brand.id)
                  ? 'bg-[#27489E] text-white border-[#27489E]' 
                  : 'bg-gray-50 text-gray-600 border-gray-200 hover:border-[#27489E] hover:bg-[#27489E]/5'}
              `}
            >
              {brand.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandFilter;
